import { createContext } from 'react';
export const PanelContext = createContext({
    dataTest: '',
    fullyClickable: false,
    hideContent: false,
    href: undefined,
    setHasMedia: () => { },
});
//# sourceMappingURL=PanelContext.js.map